import * as superagent from 'superagent';

/**
 * @deprecated
 */
export type LegacyRequest = superagent.Request;
/**
 * @deprecated
 */
export const makeEnforcementUrl = (path: string): string => {
    return `/enforcement/v2/${path}`;
};

/**
 * @deprecated
 */
export const enforcementGet = (path: string): LegacyRequest => {
    return superagent.get(makeEnforcementUrl(normalizePath(path)));
};

/**
 * @deprecated
 */
export const enforcementPut = (
    path: string,
    payload: object,
): LegacyRequest => {
    return superagent
        .put(makeEnforcementUrl(normalizePath(path)))
        .send(payload);
};

/**
 * @deprecated
 */
export const enforcementPost = (
    path: string,
    payload: object,
): LegacyRequest => {
    return superagent
        .post(makeEnforcementUrl(normalizePath(path)))
        .send(payload);
};

/**
 * @deprecated
 */
function normalizePath(path: string): string {
    return path[0] === '/' ? (path = path.substring(1)) : path;
}
